import { EmptyState } from '@wally-reseller/ui/empty-state';
import { Hourglass } from 'lucide-react';
import { useT } from '@/lib/i18n';

export function ComingSoonPage() {
  const t = useT();
  return (
    <EmptyState
      icon={Hourglass}
      title={t('portal.comingSoon')}
      description={t('portal.comingSoon.body')}
    />
  );
}
